import { createSlice } from '@reduxjs/toolkit'

const changeForgottenPasswordSlice = createSlice({
    name: 'change-forgotten-password',
    initialState: { error: null, loading: false, success: false, disabled: false },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, error: payload }
        },
        setDisabled(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, disabled: payload }
        },
        setSuccess(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, success: payload }
        },
        changeForgottenPassword() {},
    },
})

const { actions, reducer } = changeForgottenPasswordSlice

export const { setLoading, setError, setSuccess, setDisabled, changeForgottenPassword } = actions

export default reducer
